import React from "react";
import { Redirect, Route } from "react-router-dom";

import Api from "../../helpers/apiHelpers";
import {useLocation} from "react-router";

const PrivateRoute = ({children, ...rest}) => {
    const path = useLocation().pathname;
    return (
        Api.isLoggedIn?
            (
                <Route {...rest}>
                    {children}
                </Route>
            )
            :
           <Redirect to={{pathname: "/login", state: path === "/appointments" ? "" : path.substr(9)}}/>
    );
};

export default PrivateRoute;
